import { RrRequestParams } from '@/commons/types'
import { CancelTokenSource, AxiosResponse } from 'axios'
import authenticatedAxios from '@/commons/configuration/authenticated.axios'

export class RrService {
    static fetchRRInfo (
        url: string, cancelToken: CancelTokenSource, requestParams?: RrRequestParams
    ): Promise<AxiosResponse> {
        return authenticatedAxios.get(url, {
            params: requestParams || {},
            cancelToken: cancelToken.token
        })
    }
}
